import * as UI            from '../ui';
import getTwilioClient    from './authenticate';
import React              from 'react';
import store              from '../store';
import useNewLastMessages from './use_new_last_messages';


const TwilioContext = React.createContext();


export default function WaitForTwilio({ children }) {
  const [ client, setClient ]           = React.useState(null);
  const [ isConnected, setIsConnected ] = React.useState(false);
  const lastMessages                    = useNewLastMessages(client);

  // Call createTwilioClient once, and setClient with the result.
  React.useEffect(function() {
    async function createTwilioClient() {
      const twilioClient = await getTwilioClient();
      setClient(twilioClient);
    }
    createTwilioClient();
  }, []);

  // Once client is available, update connection state and listen for connection state changes.
  React.useEffect(function() {
    function updateConnectionState(state) {
      if (!isConnected)
        setIsConnected(state === 'connected');
    }

    if (client) {
      client.on('connectionStateChanged', updateConnectionState);
      updateConnectionState(client.connectionState);
    }

    return function() {
      if (client)
        client.removeListener('connectionStateChanged', updateConnectionState);
    };
  }, [ client, isConnected ]);

  React.useEffect(function() {
    if (isConnected)
      store.dispatch(UI.progressEnd());
    else
      store.dispatch(UI.progressStart());
  }, [ isConnected ]);

  if (!isConnected)
    return null;

  return (
    <TwilioContext.Provider value={{ client, lastMessages }}>
      {children}
    </TwilioContext.Provider>
  );
}

export function useTwilioContext() {
  const context = React.useContext(TwilioContext);
  return context;
}
